module.exports = __webpack_public_path__ + "img/omelette-blanc-off.adb74166.svg";